import GettingStarted from './GettingStarted';
import authRoles from "../../utils/auth.roles";
const AuthRoutes = {
  auth: authRoles.user,
  kyc: false,
  mfaNotRequired: true, 
  routes: [
    {
        path: "/getting-started",
        component: GettingStarted,
        exact: true,
      }
  ],
};
export default AuthRoutes;
